import type { Facet } from "@/mocks/fancha";

interface ContrastBlockProps {
  before: Facet;
  after: Facet;
}

function SideCard({ facet, tone }: { facet: Facet; tone: "before" | "after" }) {
  const isAfter = tone === "after";
  return (
    <div className="relative flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-8">
      <div className={`flex items-center gap-2 ${isAfter ? "text-primary-600" : "text-secondary-600"}`}>
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-lg text-background-50 ${
            isAfter ? "bg-primary-500" : "bg-secondary-500"
          }`}
        >
          <i className={`${isAfter ? "ri-focus-3-line" : "ri-user-star-line"} text-lg`} />
        </span>
        <span className="font-heading text-lg font-bold text-foreground-950">{facet.label}</span>
      </div>
      <p className="mt-3 text-sm leading-6 text-foreground-600">{facet.text}</p>
      <ul className="mt-4 space-y-2.5">
        {facet.points.map((p) => (
          <li
            key={p}
            className={`flex items-start gap-2 rounded-lg px-3 py-2.5 text-sm leading-6 ${
              isAfter ? "bg-primary-50 text-foreground-800" : "bg-secondary-50 text-foreground-800"
            }`}
          >
            <i className={`mt-1 ${isAfter ? "ri-error-warning-line text-primary-500" : "ri-circle-line text-secondary-400"}`} />
            <span>{p}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function ContrastBlock({ before, after }: ContrastBlockProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-0">
      <div className="md:pr-2"><SideCard facet={before} tone="before" /></div>
      <div className="relative md:pl-2">
        <span className="absolute left-1/2 top-1/2 z-10 hidden -translate-x-1/2 -translate-y-1/2 md:flex">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50 shadow-lift">
            <i className="ri-arrow-right-line text-xl" />
          </span>
        </span>
        <SideCard facet={after} tone="after" />
      </div>
    </div>
  );
}